import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { IntroductionSection } from "./components/IntroductionSection";
import { BenefitsSection } from "./components/BenefitsSection";
import { UniversalBenefitsSection } from "./components/UniversalBenefitsSection";
import { TechnologySection } from "./components/TechnologySection";
import { VisionSection } from "./components/VisionSection";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import AccountForm from "./components/AccountForm";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <HeroSection />
        <IntroductionSection />
        <BenefitsSection />
        <UniversalBenefitsSection />
        <TechnologySection />
        <VisionSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/abre-cuenta" element={<AccountForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
